import { render, staticRenderFns } from "./point-location.vue?vue&type=template&id=5ae6230c&scoped=true"
import script from "./point-location.vue?vue&type=script&lang=js"
export * from "./point-location.vue?vue&type=script&lang=js"
import style0 from "./point-location.vue?vue&type=style&index=0&id=5ae6230c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6230c",
  null
  
)

export default component.exports